// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDLrbsTBHSbluJXugPJtodaXdxyh6MD9DI",
  authDomain: "lsg-events.firebaseapp.com",
  projectId: "lsg-events",
  storageBucket: "lsg-events.appspot.com",
  messagingSenderId: "279610720790",
  appId: "1:279610720790:web:0ae282e9ef84c3fb8aeb37",
  measurementId: "G-1DZJXR5NJB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);


export default db;